import { SecureComApp } from "common/utils/universal/types";
import { daPalette, Palette, vkPalette } from "./theme.css";

const themeColors: Palette =
  process.env.REACT_APP_NAME === SecureComApp.DA ? daPalette : vkPalette;

export type StateColor =
  | "primary"
  | "success"
  | "warning"
  | "error"
  | "info"
  | "neutral";

export default themeColors;
